import { render, staticRenderFns } from "./CoachingPriceSection.vue?vue&type=template&id=81b89d42&scoped=true&"
import script from "./CoachingPriceSection.vue?vue&type=script&lang=js&"
export * from "./CoachingPriceSection.vue?vue&type=script&lang=js&"
import style0 from "./CoachingPriceSection.vue?vue&type=style&index=0&id=81b89d42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81b89d42",
  null
  
)

export default component.exports